import type { TransferBetweenClubs as XpaTransferBetweenClubs } from "@motain/xpa-proto-files-web/lib/types/transfer_kind_card";
import type { FC } from "react";
import { isNonNullable } from "@/types/isNonNullable";
import Link from "next/link";
import { trackingService } from "@/modules/analytics";
import { EventType } from "@motain/xpa-proto-files-web/lib/types/tracking";
import { EntityLogo } from "@/components/entity-logo/EntityLogo";
import styles from "./TransferBetweenClubs.module.scss";
import classNames from "classnames";

type TransferBetweenClubsProps = XpaTransferBetweenClubs & {
  kind?: "rumor" | "completed";
};

export const TransferBetweenClubs: FC<TransferBetweenClubsProps> = (props) => {
  const { clubOld, clubNew, kind = "rumor" } = props;
  return (
    <div
      className={classNames(
        styles.container,
        kind === "rumor" && styles.rumor,
        kind === "completed" && styles.completed,
      )}
    >
      {isNonNullable(clubOld) && isNonNullable(clubOld.clubLink) && (
        <Link
          href={clubOld.clubLink.urlPath}
          className={classNames(styles.link, styles.linkLeft)}
          onClick={() => {
            if (isNonNullable(clubOld.clubLink)) {
              trackingService.sendXpaTracking(
                clubOld.clubLink.trackingEvents,
                EventType.EVENT_CLICK,
              );
            }
          }}
        >
          {isNonNullable(clubOld.logo) && (
            <EntityLogo
              className={styles.logo}
              alt={clubOld.logo.alt}
              src={clubOld.logo.path}
              darkModeSrc={clubOld.logo.darkModePath}
              isPreloaded={clubOld.logo.isPreloaded}
              size={20}
            />
          )}
          <span className={classNames("title-8-regular", styles.name)}>
            {clubOld.clubLink.name}
          </span>
        </Link>
      )}

      <svg
        className={classNames(
          styles.arrowIcon,
          kind === "rumor" && styles.arrowIconGrey,
          kind === "completed" && styles.arrowIconGreen,
        )}
        fill="none"
      >
        <path
          d="M1 5.3C.6 5.3.5 5.1.5 5c0-.1.1-.4.5-.4h12c.4 0 .5.3.5.4 0 0-.1.3-.5.3H1Z"
          fill="currentColor"
          stroke="currentColor"
        />
        <path
          d="M10.4 9 14 5l-3.6-4"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {isNonNullable(clubNew) && isNonNullable(clubNew.clubLink) && (
        <Link
          href={clubNew.clubLink.urlPath}
          className={classNames(styles.link, styles.linkRight)}
          onClick={() => {
            if (isNonNullable(clubNew.clubLink)) {
              trackingService.sendXpaTracking(
                clubNew.clubLink.trackingEvents,
                EventType.EVENT_CLICK,
              );
            }
          }}
        >
          <span className={classNames("title-8-regular", styles.name)}>
            {clubNew.clubLink.name}
          </span>

          {isNonNullable(clubNew.logo) && (
            <EntityLogo
              className={styles.logo}
              alt={clubNew.logo.alt}
              src={clubNew.logo.path}
              darkModeSrc={clubNew.logo.darkModePath}
              isPreloaded={clubNew.logo.isPreloaded}
              size={20}
            />
          )}
        </Link>
      )}
    </div>
  );
};
